const matcher = window.matchMedia(`(min-width: 1024px)`);

const quickAddDrawerWrapper = (klaviyoCompanyId, klaviyoComingSoonListId) => ({
  klaviyoCompanyId,
  quickAddAlgoliaQueryID: null,
  quickAddDrawerProduct: null,
  quickAddDrawerSelectedOptions: null,
  quickAddDrawer: false,
  drawerTitle: '',
  drawerSide: '',
  klaviyoComingSoonListId,

  async open({ algoliaQueryID, product, selectedOptions }) {
    // always create new component instance
    this.quickAddDrawer = false;
    await this.$nextTick();
    this.drawerTitle = '';
    this.drawerSide = matcher.matches ? 'right' : 'bottom';
    this.quickAddDrawerProduct = product;
    this.quickAddDrawerSelectedOptions = selectedOptions || null;
    this.quickAddDrawer = true;
    this.quickAddAlgoliaQueryID = algoliaQueryID;
    this.$el.querySelector('dialog').showModal();
  },

  handleOpenAddDrawer(event) {
    this.open(event.detail);
  },

  async handleUpdateAddDrawerTitle(event) {
    await this.$nextTick(); // some weird race condition
    this.drawerTitle = event.detail;
  },
});

export default quickAddDrawerWrapper;
